import { getAuthHeaders } from './utils';


export const fetchBankHolidays = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/bank_holidays`, {
        headers: getAuthHeaders(),
      });
  
      if (!res.ok) {
        const error = await res.json();
        throw new Error(error.message || 'Failed to fetch bank holidays');
      }
  
      return res.json();
    } catch (error) {
      console.error('Error fetching bank holidays:', error);
      throw error;
    }
};
  

export const addBankHoliday = async (dateStr) => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/bank_holidays/add`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ date: dateStr }),
        });

        const data = await res.json();
        if (!res.ok) {
        throw new Error(data.message || 'Error adding bank holiday');
        }
        return data;
    } catch (error) {
        console.error('Error adding bank holiday:', error);
        throw error;
    }
};


export const removeBankHoliday = async (dateStr) => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/bank_holidays/remove`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
        body: JSON.stringify({ date: dateStr }),
        });

        const data = await res.json();
        if (!res.ok) {
        throw new Error(data.message || 'Error removing bank holiday');
        }
        return data;
    } catch (error) {
        console.error('Error removing bank holiday:', error);
        throw error;
    }
};
  